var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCustomerMarker = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 62,
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.059 47.059)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.441,
  cy: 7.441,
  r: 6.941,
  fill: "#FFF",
  stroke: "#0A3847"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.441,
  cy: 7.441,
  r: 3.382,
  fill: "#0A3847"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0A3847",
  d: "m18.498 45.765-1.421-1.11C16.41 44.13.706 31.678.706 18.684.706 8.643 8.69.471 18.498.471c9.812 0 17.796 8.172 17.796 18.214 0 12.994-15.707 25.446-16.374 25.97z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M27.397 18.019a30 30 0 0 0-.62-.946c-.552-.802-1.39-1.541-2.028-2.27l-.036-.31a57 57 0 0 0-.184-1.431c-.085-.546.099-1.627.001-2.124-.052-.266-.214-.44-.5-.469a16 16 0 0 0-.43-.044c-.373-.029-.744-.064-1.116-.08-.286-.013-.5.21-.503.497-.003.337.002.674 0 1.011l-.003.006c-.224-.184-.46-.35-.689-.525a29 29 0 0 0-.928-.67l-.315-.203c-.26-.173-.522-.52-.791-.682-.384-.226-.765-.236-1.16-.002-1.615.95-3.07 2.284-4.409 3.591a24.6 24.6 0 0 0-3.12 3.705q-.321.466-.623.946c-.23.366-.056.734.373.787.563.073 1.776.139 2.36.193.013.8.06 1.915.075 2.711.006.247.012.494.028.74q.047.715.104 1.428c.028.347.056.694.095 1.039.049.453.114.903.166 1.356.036.314.223.497.538.49h2.99v-5.327h3.996v5.327h2.98l.042.002a.49.49 0 0 0 .517-.432q.089-.58.155-1.162.082-.711.147-1.424c.032-.372.053-.745.072-1.116.03-.605.063-1.208.079-1.813.013-.515.004-1.303.005-1.819.585-.054 1.796-.12 2.36-.193.428-.053.603-.42.372-.787"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCustomerMarker);
export default ForwardRef;